<template>
  <div></div>
</template>

<script>
import auth from './../../auth'

export default {
  name: 'JwtSession',
  created () {
    let token = this.$route.params.token
    let path = this.$route.params.path
    auth.saveToken(token)
    this.$router.push({ path: decodeURIComponent(path) })
  }
}
</script>
